const RegistrationMarketingConsentEnum = Object.freeze({
    SOFTNO: 'SOFTNO',
    SOFTYES: 'SOFTYES'
});

export default RegistrationMarketingConsentEnum;
